import * as React from 'react';
import classNames from 'classnames';
import styles from './helper.module.esm.js';

var Caret = function (_a) {
    var direction = _a.direction, className = _a.className;
    return (React.createElement("span", { className: classNames(styles.iconWrapper, styles[direction], className) },
        React.createElement("svg", { fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { clipRule: "evenodd", d: "M18.0566 7H5.94336C5.10459 7 4.68455 8.02183 5.27763 8.61943L11.3343 14.7222C11.7019 15.0926 12.2981 15.0926 12.6657 14.7222L18.7223 8.61943C19.3155 8.02183 18.8954 7 18.0566 7Z", fill: "#128279", fillRule: "evenodd" }))));
};

export { Caret as default };
//# sourceMappingURL=Caret.esm.js.map
